import React from 'react';

const ServerIcon = ({ type }) => {
  let iconName = 'cube'; // Default icon
  
  switch (type) {
    case 'Serveur applicatif':
      iconName = 'server-stack';
      break;
    case 'Serveur base de données':
      iconName = 'database';
      break;
    case 'Serveur interop':
      iconName = 'arrows-right-left';
      break;
    case 'Serveur tout-en-un':
      iconName = 'cube';
      break;
    default:
      iconName = 'cube';
  }
  
  return (
    <span className="server-icon">
      <img src={`/icons/${iconName}.svg`} alt={type} />
    </span>
  );
};

export default ServerIcon;